/** Same wording as onboarding post-save (Apple → web) so modal and chat stay aligned. */
export const CONNECT_GOOGLE_FOR_WEB_PROMPT =
  'Would you like to connect your Google account so you can open RE-BUILD-ME-PRO in a web browser too? Reply yes or no.';

export const GO_HOME_JOURNAL_PROMPT =
  'Would you like to continue on Home and keep chatting with your coach? Reply yes when you are ready.';
